import React from "react";
import { Container } from "react-bootstrap";
import { Link } from "react-router-dom";
import Navbar from "../Navbar";
import SignOut from "../SignOut";
import Footer from "../footer";
import "react-datepicker/dist/react-datepicker.css";
import "./reportPage.css";

export const FIRST_PAGE = 15;
export const PAGE_STEP = 20;

export const toNumber = (value) => {
  const number = Number.parseFloat(value);
  return Number.isNaN(number) ? 0 : number;
};

// Same search the report pages always had: every space or comma separated word must appear in the name.
export const matchesSearch = (names, search) => {
  const terms = (search || "").toLowerCase().split(/[,\s]+/).filter(Boolean);
  const haystack = (names || "").toLowerCase();
  return terms.every((term) => haystack.includes(term));
};

export function ReportLayout({ children }) {
  return (
    <div>
      <div className="contentdashbord">
        <Navbar />
        <SignOut />
        <br />
        <Container fluid>
          <h6 className="activejobs">Reports</h6>
          <div className="report">
            <Link to="/Main/IncomeReport" className="contrilink">
              Income
            </Link>
            <Link to="/Main/ExpenseReport" className="contrilink">
              Expense
            </Link>
            <Link to="/Main/Cashbook" className="contrilink">
              Cash Book
            </Link>
            <Link to="/Main/Financialstatements" className="contrilink">
              Financial Statements
            </Link>
          </div>
          {children}
          <br />
        </Container>
      </div>
      <br />
      <Footer />
    </div>
  );
}

export function ReportCard({ title, subtitle, onDownload, downloadLabel, children }) {
  return (
    <section className="report-card">
      <header className="report-title">
        <h2>
          {title} <span className="unity">{subtitle}</span>
        </h2>
        {onDownload && (
          <button type="button" className="report-download" onClick={onDownload} aria-label={downloadLabel} title={downloadLabel}>
            <i className="fas fa-download" aria-hidden="true"></i>
          </button>
        )}
      </header>
      {children}
    </section>
  );
}

export function ReportFilters({ children }) {
  return <div className="report-filters">{children}</div>;
}

export function ReportField({ label, children }) {
  return (
    <div className="report-field">
      <span>{label}</span>
      {children}
    </div>
  );
}

export function RoundSelect({ rounds, value, onChange }) {
  return (
    <ReportField label="Round">
      <select value={value} onChange={onChange} aria-label="Select round">
        <option value="">Select Round</option>
        {rounds.map((round) => (
          <option key={round.roundID} value={round.roundID}>
            {round.roundName}
          </option>
        ))}
      </select>
    </ReportField>
  );
}

export function SearchField({ label, value, onChange }) {
  return (
    <ReportField label={label}>
      <input type="text" className="report-input" placeholder={`Search ${label.toLowerCase()}`} aria-label={`Search ${label.toLowerCase()}`} value={value} onChange={onChange} />
    </ReportField>
  );
}

export function ReportSummary({ items }) {
  return (
    <dl className="report-summary">
      {items.map((item) => (
        <div key={item.label} className={item.highlight ? "report-highlight" : undefined}>
          <dt>{item.label}</dt>
          <dd>{item.value}</dd>
        </div>
      ))}
    </dl>
  );
}

export function ReportEmpty({ children }) {
  return <p className="report-empty">{children}</p>;
}

export function ReportTable({ columns, children }) {
  return (
    <div className="report-table-wrap">
      <table className="report-table">
        <thead>
          <tr>
            {columns.map((column) => (
              <th key={column.label} className={column.numeric ? "num" : undefined}>
                {column.label}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>{children}</tbody>
      </table>
    </div>
  );
}

export function ReportFooter({ shown, total, onMore }) {
  return (
    <div className="report-footer">
      <span>
        Showing {shown} of {total}
      </span>
      {shown < total && (
        <button type="button" className="report-more" onClick={onMore}>
          <i className="fas fa-chevron-down" aria-hidden="true"></i> Load more
        </button>
      )}
    </div>
  );
}
